import { useLocation, useNavigate } from 'react-router';
import { Product } from 'screens/Checkout';

export function useCheckoutNavigate(product: Product) {
  const navigate = useNavigate();
  const location = useLocation();
  return () => navigate('/checkout', { state: { product, from: location } });
}
